export const initMapTiles = (L) => {
  // OpenStreetMap
  const osmTiles = L.tileLayer(
    "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    {
      /*attribution: `
        <a href="https://www.openstreetmap.org/copyright">OSM</a> |
        <a href="https://postimees.ee">Postimees</a>
      `,*/
    }
  );

  // Maa-amet
  const attribution = `
        <a href="https://geoportaal.maaamet.ee/est">Maa-amet</a> |
        <a href="https://postimees.ee">Postimees</a>
      `;

  const maaametTiles = new L.TileLayer(
    "https://tiles.maaamet.ee/tm/tms/1.0.0/kaart@GMC/{z}/{x}/{y}.jpg&ASUTUS=postimees",
    {
      // attribution,
      continuousWorld: true,
      tms: true,
      worldCopyJump: true,
      updateWhenIdle: false,
    }
  );

  const maaametFotoTiles = new L.TileLayer(
    "https://tiles.maaamet.ee/tm/tms/1.0.0/foto@GMC/{z}/{x}/{y}.jpg&ASUTUS=postimees",
    {
      // attribution,
      continuousWorld: true,
      tms: true,
      worldCopyJump: true,
      updateWhenIdle: false,
    }
  );

  //
  return { osmTiles, maaametTiles, maaametFotoTiles };
};
